import React from 'react';
import { useRouter } from 'next/router';

import { Row, Col, Menu } from 'antd';
import Link from 'next/link';
import {
  TrophyOutlined,
  FlagOutlined,
  EnvironmentOutlined,
  AimOutlined,
  ThunderboltOutlined,
  ReadOutlined,
} from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export default function Navigation() {
  const router = useRouter();
  const current = `/${router?.pathname.split('/')[1]}`;
  const { t } = useTranslation();

  const navigation = [
    { textKey: 'nav.leagues',        url: '/ligler',          icon: <TrophyOutlined /> },
    { textKey: 'nav.clubs',          url: '/kulupler',        icon: <EnvironmentOutlined /> },
    { textKey: 'nav.courts',         url: '/kortlar',         icon: <AimOutlined /> },
    { textKey: 'nav.tournaments',    url: '/turnuvalar',      icon: <FlagOutlined /> },
    { textKey: 'nav.trainings',      url: '/antrenmanlar',    icon: <ThunderboltOutlined /> },
    { textKey: 'nav.tennisGuide',    url: '/tenis',           icon: <ReadOutlined />, fallback: 'Tenis Rehberi' },
  ];

  return (
    <Row>
      <Col span={24}>
        <div className="header-menu">
          <div className="header-menu-inline">
            <Menu mode="horizontal" selectedKeys={[current]}>
              {navigation.map((item) => (
                <Menu.Item key={item.url} icon={item.icon}>
                  <Link href={item.url}>
                    <a>{t(item.textKey, item.fallback || '')}</a>
                  </Link>
                </Menu.Item>
              ))}
            </Menu>
          </div>
        </div>
      </Col>
    </Row>
  );
}
